export const dayAbbreviations = [
  "Mon",
  "Tue",
  "Wed",
  "Thu",
  "Fri",
  "Sat",
  "Sun",
];

export const fullDayNameMap = {
  Mon: "Monday",
  Tue: "Tuesday",
  Wed: "Wednesday",
  Thu: "Thursday",
  Fri: "Friday",
  Sat: "Saturday",
  Sun: "Sunday",
};

export const weekDayMap = {
  Mon: 1,
  Tue: 2,
  Wed: 3,
  Thu: 4,
  Fri: 5,
  Sat: 6,
  Sun: 0, // Sunday is represented by 0 in Js
};

export const VARIABLE_TAX_RATE = "variable";

export const MAX_FIRST_NAME_LENGTH = 15;
export const LOCATION_PREFIXES = ["PL", "CL", "GL"];
export const LOCATION_PREFIXES_REGEX = new RegExp(
  LOCATION_PREFIXES.join("-|^")
);
export const AGNOSTIC_PROVIDER_NAME_TRUNCATE_LENGTH = 9;
export const SERVICE_BEHAVIOR_INTERNAL = "INTERNAL";
export const SERVICE_BEHAVIOR_EXTERNAL = "EXTERNAL";

export const SENTRY_POPUP_ENV = "development";
export const TIME_OF_DAY = [
  "12:00 AM – 2:00 AM",
  "2:00 AM – 4:00 AM",
  "4:00 AM – 6:00 AM",
  "6:00 AM – 8:00 AM",
  "8:00 AM – 10:00 AM",
  "10:00 AM – 12:00 PM",
  "12:00 PM – 2:00 PM",
  "2:00 PM – 4:00 PM",
  "4:00 PM – 6:00 PM",
  "6:00 PM – 8:00 PM",
  "8:00 PM – 10:00 PM",
  "10:00 PM – 12:00 AM",
];
export const DEFAULT_TIME_OF_DAY_INDICES = [4, 5, 6, 7, 8];

export const MB_WARNING_COLOR_DARK = "rgba(139,0,0,1)";
export const MB_WARNING_COLOR_MAIN = "rgba(218, 1, 1, 1)";
export const MB_WARNING_COLOR_LIGHT = "rgba(218, 1, 1, 0.1)";
export const MB_INFO_COLOR_MAIN = "rgba(0, 135, 238, 1)";
export const MB_INFO_COLOR_LIGHT = "rgba(0, 135, 238, 0.2)";
export const MB_INFO_COLOR_LIGHTEST = "rgba(0, 135, 238, 0.1)";
export const MB_SUCCESS_COLOR_DARK = "rgba(21, 115, 0, 1)";
export const MB_SUCCESS_COLOR_MAIN = "rgba(82, 163, 0, 1)";
export const MB_SUCCESS_COLOR_LIGHT = "rgba(67, 182, 91, 0.2)";
export const MB_HELPERTEXT_COLOR_MAIN = "rgb(167,167,167)";
export const MB_INPUT_BORDER_COLOR_MAIN = "rgb(0,0,0,0.23)";
export const MB_CAUTION_COLOR_MAIN = "rgba(249, 97, 6, 1)";
export const MB_CAUTION_COLOR_LIGHT = "rgba(249, 97, 6, 0.25)";
export const MB_BODY_COLOR_MAIN = "#6b6b6b";
export const MB_TRANSPARENT_MAIN = "rgba(0,0,0,0)";
export const MB_GREY_MEDIUM = "#A7A7A7";
export const MB_GREY_LIGHT = "#D9D9D9";
export const MB_GREY_LIGHTEST = "#F4F4F4";
export const MB_DISABLED_MAIN = "#C4C4C4";
